export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl translate-y-1/2 -translate-x-1/4 pointer-events-none"></div>

      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide mb-5">
              全网最全免费吃瓜平台
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
              吃瓜群
              <span className="block text-primary-500 mt-1">最新娱乐八卦 · 热点事件追踪</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-500 mt-2 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              吃瓜群众的快乐老家，每天都有新鲜瓜
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] lg:max-w-none mb-8">
              吃瓜群汇聚全网最新娱乐八卦、热点事件与争议话题，覆盖明星恋情、影视综艺、网红直播、电竞游戏等30多个领域。
              无需注册登录，打开即看，全天候持续更新。<strong className="text-foreground-800">理性吃瓜，快乐分享</strong>——我们致力于
              让每一位吃瓜群众都能第一时间掌握事件全貌，不错过任何一个值得关注的精彩瓜条。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>12,580+</div>
                <div className="text-xs text-foreground-500 mt-1">累计更新瓜条</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500" style={{ fontFamily: 'var(--font-heading)' }}>86万+</div>
                <div className="text-xs text-foreground-500 mt-1">日均访问用户</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-500" style={{ fontFamily: 'var(--font-heading)' }}>50条+</div>
                <div className="text-xs text-foreground-500 mt-1">日均更新内容</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors duration-200"
              >
                <i className="ri-compass-3-line text-lg"></i>
                开始吃瓜
              </a>
              <a
                href="#carousel"
                className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-8 py-3.5 bg-background-100 text-foreground-700 font-medium text-sm rounded-md border border-background-300/60 hover:bg-background-200 transition-colors duration-200"
              >
                <i className="ri-article-line text-lg"></i>
                焦点专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20stylized%20illustration%20of%20people%20gathering%20around%20a%20giant%20watermelon%20split%20open%20revealing%20glowing%20news%20and%20social%20media%20icons%2C%20warm%20coral%20and%20amber%20tones%2C%20playful%20yet%20modern%20Chinese%20editorial%20illustration%20style%2C%20clean%20composition%20with%20soft%20gradients%2C%20light%20cream%20background&width=960&height=720&seq=hero-main-visual&orientation=landscape"
                alt="吃瓜群 - 吃瓜群众在线吃瓜娱乐八卦热点追踪"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}